import { Building2, Shield, Users, Briefcase } from "lucide-react";

export const BusinessCoverage = () => {
  return (
    <section className="py-12 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white p-8 rounded-lg shadow-sm animate-scale-in" style={{ animationDelay: "0.2s" }}>
            <h2 className="text-2xl font-semibold text-primary-dark mb-4">
              Core Coverage
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Building2 className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Property Insurance</h3>
                  <p className="text-neutral">Protection for your business property and assets.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Shield className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">General Liability</h3>
                  <p className="text-neutral">Coverage for third-party injuries and property damage.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Users className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Workers Compensation</h3>
                  <p className="text-neutral">Protection for your employees in case of work-related injuries.</p>
                </div>
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-sm animate-scale-in" style={{ animationDelay: "0.4s" }}>
            <h2 className="text-2xl font-semibold text-primary-dark mb-4">
              Specialized Coverage
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Briefcase className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Professional Liability</h3>
                  <p className="text-neutral">Protection against claims of professional negligence.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Building2 className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Business Interruption</h3>
                  <p className="text-neutral">Coverage for lost income during temporary closures.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Shield className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Cyber Liability</h3>
                  <p className="text-neutral">Protection against data breaches and cyber attacks.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};